import React, { useRef } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { useLocale } from 'locale';
import UpgradePlanIcon from 'assets/svg/private-bulletin-promotion/upgrade-plan-icon.svg';
import { CustomButton } from 'components/private-bulletin-promotion/CustomButton';
import {
  openAgentSupportModal as openAgentSupportModalAction,
  upgradeUserPlanFlow,
} from 'store/state/app/actions';
import { RootAction, State } from 'store/state';
import { isAgentSelector } from 'store/state/domainData/selectors';
import { AgentSupportModalVariant, PrivateUserMonetizationSource } from 'store/state/app';


interface UpgradePlanButtonProps {
  onUpgradePromotionPlanClick?: () => void;
  isAgent?: boolean;
  openAgentSupportModal?: () => void;
  privateUserMonetizationPopupSource: PrivateUserMonetizationSource;
}

const UpgradePlanButton: React.FC<UpgradePlanButtonProps> = props => {
  const { onUpgradePromotionPlanClick, isAgent, openAgentSupportModal } = props;
  const { t } = useLocale();
  const buttonRef = useRef(null);

  const handleUpgradePromotionPlan = () => {
    if (isAgent) {
      if (openAgentSupportModal) openAgentSupportModal();
      return;
    }
    if (onUpgradePromotionPlanClick) onUpgradePromotionPlanClick();
  };

  return (
    <>
      <CustomButton
        ref={buttonRef}
        mode="primary"
        size="extraLarge"
        onClick={handleUpgradePromotionPlan}
      >
        <UpgradePlanIcon width={21} height={21} />
        {t('privateBulletinPromotion.upgradePlanButton')}
      </CustomButton>
    </>
  );
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>, ownProps: UpgradePlanButtonProps) => ({
  onUpgradePromotionPlanClick: () => dispatch(upgradeUserPlanFlow({ source: ownProps.privateUserMonetizationPopupSource, userInitiated: true })),
  openAgentSupportModal: () => dispatch(openAgentSupportModalAction({ variant: AgentSupportModalVariant.MONETIZATION })),
});

const mapStateToProps = (state: State) => ({
  isAgent: isAgentSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpgradePlanButton);
